import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import Link from "../components/Link";

const AnchorNav = ({ items }) => {
    const [activeId, setActiveId] = useState("");
    const [isSticky, setIsSticky] = useState(false);
    const [navHeight, setNavHeight] = useState(0);
    const wrapperRef = useRef(null);
    const navRef = useRef(null);

    useEffect(() => {
        const getStickyOffset = () =>
            window.matchMedia("(max-width: 767px)").matches ? 72 : 88;

        const handleScroll = () => {
            const stickyOffset = getStickyOffset();
            const currentNavHeight = navRef.current?.offsetHeight || 0;
            const wrapperTop =
                wrapperRef.current?.getBoundingClientRect().top ?? 0;

            setIsSticky(wrapperTop <= stickyOffset);
            setNavHeight(currentNavHeight);

            const sections =
                items
                    ?.map(({ target }) => ({
                        target,
                        element: document.getElementById(target),
                    }))
                    .filter(({ element }) => element) ?? [];

            const scrollPos = window.scrollY + stickyOffset + currentNavHeight + 20;

            for (let i = sections.length - 1; i >= 0; i--) {
                const { target, element } = sections[i];
                if (element.offsetTop <= scrollPos) {
                    setActiveId(target);
                    break;
                }
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [items]);

    const handleClick = (e, target) => {
        e.preventDefault();
        const el = document.getElementById(target);
        if (el) {
            const stickyOffset =
                window.matchMedia("(max-width: 767px)").matches ? 72 : 88;
            const offset = navRef.current?.offsetHeight || 0;
            const top = el.offsetTop - stickyOffset - offset - 20;
            setActiveId(target);
            window.scrollTo({ top, behavior: "smooth" });
        }
    };

    if (!items || items.length === 0) return null;

    return (
        <div
            className="anchor-nav__wrapper"
            ref={wrapperRef}
            style={{ height: isSticky ? navHeight : undefined }}
        >
            <div
                className={`anchor-nav ${
                    isSticky ? "anchor-nav--sticky" : ""
                }`}
                ref={navRef}
            >
                <Container>
                    <nav className="anchor-nav__inner">
                        {items.map(({ label, target }, index) => (
                            <Link
                                key={index}
                                to={`#${target}`}
                                className={`anchor-nav__link ${
                                    activeId === target
                                        ? "anchor-nav__link--active"
                                        : ""
                                }`}
                                onClick={(e) => handleClick(e, target)}
                            >
                                {label}
                            </Link>
                        ))}
                    </nav>
                </Container>
            </div>
        </div>
    );
};

export default AnchorNav;
